"use client"

import { useState, useEffect } from "react"
import { Sidebar } from "../components/layout/Sidebar"
import Header from "../components/layout/Header"
import { getContactMessages } from "../api/support"
import { SupportMessageList } from "../components/support/SupportMessageList"

export default function AdminSupport() {
  const [messages, setMessages] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [statusFilter, setStatusFilter] = useState(null)

  useEffect(() => {
    fetchMessages()
  }, [statusFilter])

  const fetchMessages = async () => {
    try {
      setLoading(true)
      const response = await getContactMessages(statusFilter)
      if (response.success) {
        setMessages(response.data)
      }
    } catch (err) {
      setError(err.message)
      console.log("[v0] Support API error:", err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Support Messages</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">Dashboard</li>
                  {/* <li className="breadcrumb-item active">Support</li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${statusFilter === null ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setStatusFilter(null)}
                >
                  All
                </button>
                <button
                  type="button"
                  className={`btn ${statusFilter === "New" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setStatusFilter("New")}
                >
                  New
                </button>
                <button
                  type="button"
                  className={`btn ${statusFilter === "Closed" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setStatusFilter("Closed")}
                >
                  Closed
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <SupportMessageList messages={messages} loading={loading} onRefresh={fetchMessages} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
